const getRuntimeConfig = () => window.APP_CONFIG || {};

export const getConfigValue = (key, fallback = '') => {
  const runtimeValue = getRuntimeConfig()[key];

  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
    return runtimeValue;
  }

  return process.env[key] || fallback;
};

export const getWebAppUrl = () => getConfigValue('REACT_APP_WEB_APP_URL').replace(/\/$/, '');

export const getCiraServiceEndpoint = () =>
  getConfigValue('REACT_APP_CIRA_SERVICE_ENDPOINT_NODE').replace(/\/$/, '');
